import { Bloc, IBlocAsyncInteractor, delay } from "@kernel/frontend-react-app";
import { MainState, defaultMainState } from "./MainState";
import { MainBloc } from "./MainBloc";
import {
  LoadConfigInteractor,
  LoadConfigInteractorProps
} from "./interactors/config/LoadConfigInteractors";

export type AppConfigState = Pick<MainState, "config">;

const defaultConfigState: AppConfigState = {
  config: defaultMainState.config
};

export type AppConfigInteractors = {
  loadConfig: IBlocAsyncInteractor<unknown, LoadConfigInteractorProps>;
};

export class AppConfigBloc extends Bloc<AppConfigState> {
  private constructor(
    private mainBloc: MainBloc,
    private interactors: AppConfigInteractors
  ) {
    super(defaultConfigState);
  }

  public async load(keys: string[]) {
    this.mainBloc.startLoading("Caricamento configurazioni...");
    const config = (await this.interactors.loadConfig.execute({
      keys
    })) as AppConfigState["config"];
    await delay(MainBloc.DELAY_MS);
    this.mainBloc.stopLoading();
    this.changeState({ ...this.state, config });
  }

  public static create(parent: MainBloc) {
    const interactors: AppConfigInteractors = {
      loadConfig: LoadConfigInteractor.create()
    };

    const bloc = new AppConfigBloc(parent, interactors);
    bloc.subscribe((state: AppConfigState) => {
      parent.changeState({
        ...parent.state,
        config: state.config
      });
    });
    return bloc;
  }
}
